import React from 'react';
import './index.css';
import App from './components/App/App';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(<App />);